<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;"
    >About Us</h4>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p style="text-align:justify;font-size:18px;">
            Hi,
            <br />
            <br />Thank you for visiting this website and appreciate your interest in knowing more about snakes.
            <br />
            <br />Our effort is to share knowledge about snakes of India through this website and associated mobile applications so that people learn more about snakes and worry less about snakebites. Our aim is to create awareness about snakes and snakebite across the country so that both people and snakes can exist together without killing each other.
            <br />
            <br />The website was first launched in 2010 and since then we maintain this site as one of the leading platform on information related to snakes of India. Several volunteers work behind this website who contribute their time, skills and knowledge to ensure that the site is kept updated.
            <br />
            <br />The new design was published in November 2019 which is completely optimised for mobile devices and with faster search options. The techie team is working on some more tweaks to ensure smooth user experience.
            <br />
            <br />Thank you for dropping in and do come back – We are in the process of constantly updating the site with more information.<br />
            <br />With Regards
            <br />Jose Louies ( Founder )
            <br />Indiansnakes.org
            <br />
            <br />
            <i>
              For more information please write to
              <a href="mailto:jose@indiansnakes.org">jose@indiansnakes.org</a> or call on 9319165075
            </i>
            <br />
           </p>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-6">  <img src="../assets/partners.jpeg" width="100%" height="auto"></div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    Navbar
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>